import React from 'react';
import Radium from 'radium';

import { Formik } from 'formik';
import Yup from 'yup';


import {SubmitButton, RGForm, ComboBox} from 'views/FormElements';

import HttpService from 'service/HttpService';

import {A} from 'views/AppElements';

class SalesTargetForm extends React.Component {

	constructor(props) {
		super(props);

		const product = props.product;
		const currentTarget = this.props.currentTarget;
		
		this.TARGET_OPTIONS = Object.keys(product.salesTargetCommissionConfig)
									.filter(k => k > currentTarget.salesTarget)
									.map(function(k) {
										return {label: k, value: k};
								});

		

		this.INIT_VALUES = {salesTarget: this.TARGET_OPTIONS.length > 0? this.TARGET_OPTIONS[0].label: ''};

		this.validationScheme = this.validationScheme.bind(this);
		this.handleFormSubmission = this.handleFormSubmission.bind(this);
	}

	validationScheme() {
		return Yup.object().shape({
			salesTarget: Yup.string().required("Select a sales target")
		});
	}

	handleFormSubmission(value, {setSubmitting, resetForm}) {
		const selectedTarget = value.salesTarget;

		const productId = this.props.product.id;

		HttpService.increaseCurrentTarget(productId, selectedTarget, function(success) {
			setSubmitting(false);

			if(success) {
				resetForm();
				HttpService.getProductStat(productId);
			}
				
		});
	}

	render() {
		const product = this.props.product;
		if(this.TARGET_OPTIONS.length === 0)
			return <h4>You have completed your sales targets. Click <A href="/designer/dashboard">here</A> to withdraw it.</h4>;

		return <div id="salesTargetForm">
				<h4>You can either <A href="/designer/dashboard">withdraw</A> it or increase your target to earn more.</h4>

				<div style={{width: '30%', margin: '0 auto', '@media (max-width: 770px)': {width: '100%'}}}>
					<Formik initialValues={this.INIT_VALUES} onSubmit={this.handleFormSubmission}
							validationSchema={this.validationScheme} 
							render={({values, setFieldValue, isSubmitting}) => {

							let submitBtn = 'Submit';
			
							if(isSubmitting === true)
								submitBtn = <span>Submitting <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></span>;

							const commission = values.salesTarget? (product.salesTargetCommissionConfig[values.salesTarget]/100.0) * product.margin: null;
							return <RGForm>
								<ComboBox name="salesTarget" value={values.salesTarget} 
												options={this.TARGET_OPTIONS} placeholder="Select Target" 
												clearable={false} />

								{
									commission &&
									<h4>You can earn <b>Rs. {commission}</b> per quantity sold.</h4>
								}

								<SubmitButton color="primary" disabled={isSubmitting} style={{width: '100%'}}>{submitBtn}</SubmitButton>
							</RGForm>
					}} />
				</div>
		</div>
	}
}

export default Radium(SalesTargetForm);



// WEBPACK FOOTER //
// ./src/views/designer/SalesTargetForm.js